import Vue from "vue";
import Router from "vue-router";

import ClientForm from "@/components/ClientForm";
import DetailsForm from "@/components/DetailsForm";
import CustomerResearch from "@/components/CustomerResearch";
// import CustomerResearchMail from "@/components/CustomerResearchMail";
import ApkForm from "@/components/apk/APKForm";
import narrowTemplate from "@/components/partials/misc/narrowTemplate";
// import holidayTemplate from "@/components/partials/misc/holidayTemplate";
// import Holidays from "@/components/Holidays";
import Unsubscribe from "@/components/Unsubscribe";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/recruit/:shortcut?",
      beforeEnter(to, from, next) {
        const recruitUrl = process.env.VUE_APP_recruit_url;

        if (!recruitUrl) {
          next(false);
          return;
        }

        const baseUrl = recruitUrl.replace(/\/$/, "");
        const shortcut = to.params.shortcut
          ? `/${encodeURIComponent(to.params.shortcut)}`
          : "";

        window.location.replace(`${baseUrl}/recruit${shortcut}`);
      },
    },
    {
      path: "/client/apk/:base/:prevent?",
      beforeEnter(to, from, next) {
        const apkUrl =
          process.env.VUE_APP_apk_url || "http://apk.angfinanse.pl";

        if (!apkUrl) {
          next(false);
          return;
        }

        const baseUrl = apkUrl.replace(/\/$/, "");
        const clientUid = encodeURIComponent(to.params.base);
        const prevent = to.params.prevent
          ? `/${encodeURIComponent(to.params.prevent)}`
          : "";

        window.location.replace(`${baseUrl}/${clientUid}${prevent}`);
      },
    },
    // {
    //   path: "/holi",
    //   component: narrowTemplate,
    //   children: [{ path: "/holi", component: Holidays }],
    // },
    {
      path: "/unsubscribe",
      component: narrowTemplate,
      children: [{ path: "/unsubscribe/:hash", component: Unsubscribe }],
    },
    {
      path: "/",
      component: narrowTemplate,
      children: [
        { path: "/research/:uid", component: CustomerResearch },
        // { path: "/mail", component: CustomerResearchMail },
        { path: "/client/apk/:base/:prevent?", component: ApkForm },
        { path: "/:solicitor?", component: ClientForm },
        { path: "/base/:base", component: ClientForm },
        {
          path: "/biznes/:solicitor",
          component: ClientForm,
          meta: { biznes: true },
        },
        { path: "/:base/:solicitor", component: ClientForm },
        { path: "/client/forms/details/:base/:code?", component: DetailsForm },
      ],
    },
  ],
});
